import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';

const DOCKING_HEIGHT_WITH_RIBBON = 120;
const DOCKING_HEIGHT_WITHOUT_RIBBON = 72;

export default function getBottomDockingHeight() {
    const fullComposeViewState = getFullComposeViewState();
    return fullComposeViewState.isRibbonShown
        ? DOCKING_HEIGHT_WITH_RIBBON
        : DOCKING_HEIGHT_WITHOUT_RIBBON;
}
